import { ApplicationState } from '@mews-commander/types';

export const createModuleSelector =
    <ModuleState>(moduleName: string) =>
    (state: ApplicationState) =>
        state[moduleName] as ModuleState;
